{
  "pt": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Adicionar um responsável",
        "bulk_remove": "Remover da tarefa",
        "change_status": "Alterar estado",
        "confirm": "Marcar como concluída",
        "create": "Tarefa",
        "delete": "Eliminar responsável",
        "due_in_month": "Dentro de um mês",
        "due_in_two_weeks": "Dentro de duas semanas",
        "due_in_week": "Dentro de uma semana",
        "due_remove": "Remover prazo",
        "move_to_draft": "Colocar em rascunho",
        "reopen": "Reabrir",
        "selectAll": "Selecionar todas ({total})",
        "send_and_notify": "Enviar e notificar",
        "set_due_date": "Definir prazo",
        "set_status": "Definir estado",
        "unSelectAll": "Desmarcar tudo"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Funcionário",
        "partner": "Parceiro"
      },
      "attributes": {
        "assignee": "Responsável",
        "assignees": "Responsáveis",
        "comment": "Comentário",
        "created_at": "Criado",
        "document": "Documento",
        "due_date": "Prazo",
        "project": "Projeto",
        "status": "Estado",
        "task": "Tarefa",
        "unit": "Unidade"
      },
      "confirm": {
        "affected": "Isto afeta {customers} e {team}.",
        "affected_customers": "Isto afeta {customers}.",
        "affected_team": "Isto afeta {team}.",
        "bulk_affected": "Isto escreve {count} tarefa. | Isto escreve {count} tarefas.",
        "bulk_delete_body": "A tarefa continua a existir, nesta unidade e em todas as outras. Apenas as linhas selecionadas desaparecem.",
        "bulk_delete_header": "Remover estas tarefas?",
        "complete_body": "As tarefas deles ficam fechadas e desaparecem da lista, mesmo que não tenham feito nada.",
        "complete_header": "Fechar esta tarefa para todos?",
        "customer_tasks": "{count} tarefa de cliente | {count} tarefas de cliente",
        "delete_body": "Só esta atribuição desaparece. A tarefa mantém os seus outros responsáveis e as suas outras unidades.",
        "delete_header": "Eliminar {name} desta tarefa?",
        "delete_sent_customers": "Esta já tinha sido enviada, por isso desaparece também do portal de clientes de {unit}.",
        "delete_sent_team": "Esta já tinha sido enviada, por isso desaparece também da lista de {name}.",
        "draft_body": "A tarefa desaparece até ser enviada outra vez. Os e-mails que já saíram continuam enviados.",
        "draft_header": "Voltar a colocar esta tarefa em rascunho?",
        "send_customers": "Os clientes veem a tarefa de imediato no portal e recebem uma notificação.",
        "send_header": "Enviar para os responsáveis?",
        "send_permanent": "O envio não pode ser anulado. Voltar a colocar a tarefa em rascunho mais tarde não retira a notificação.",
        "send_status": "Ficam em Solicitado.",
        "send_team": "Os membros da equipa são notificados.",
        "team_tasks": "{count} tarefa de equipa | {count} tarefas de equipa"
      },
      "filters": {
        "due_window_values": {
          "month": "Prazo dentro de um mês",
          "none": "Sem prazo",
          "overdue": "Em atraso",
          "week": "Prazo dentro de uma semana"
        },
        "show_only": "Mostrar apenas",
        "show_only_values": {
          "customers": "Clientes",
          "mine": "Atribuídas a mim",
          "team": "Equipa"
        }
      },
      "labels": {
        "add_assignee": "Adicionar responsável…",
        "add_customers": "Adicionar clientes",
        "already_assigned": "Esta tarefa já foi adicionada a esta unidade.",
        "already_assigned_project": "Esta tarefa já foi adicionada a este projeto.",
        "assignees": "Atribuídos",
        "comment_earlier": "+{count} anteriores",
        "comment_earlier_round": "ronda anterior",
        "comment_placeholder": "p. ex. o contador era difícil de alcançar, esta é a melhor foto que consegui tirar",
        "comments_none": "O cliente não deixou nenhum comentário.",
        "comments_title": "Comentários sobre esta tarefa",
        "completed": "Concluídas",
        "confirm_message": "Tem a certeza de que pretende marcar esta tarefa como concluída?",
        "customers": "Clientes",
        "my_tasks": "As minhas tarefas",
        "no_assignees": "Ainda não há responsáveis.",
        "no_assignments": "Ainda não há tarefas.",
        "no_assignments_task": "Ainda não há atribuições para esta tarefa.",
        "no_assignments_unit": "Ainda não há tarefas para esta unidade.",
        "required": "Este campo é obrigatório",
        "selectOne": "Selecione pelo menos uma tarefa.",
        "select_task": "Selecione uma tarefa",
        "selected": "{selected} selecionada | {selected} selecionadas",
        "set_status_for": "Definir o estado de {name}",
        "totalSelected": "Todas as {total} selecionadas",
        "upload_hint": "Carregue o(s) documento(s) solicitado(s) para concluir esta tarefa.",
        "uploaded_documents": "Documentos carregados"
      },
      "statuses": {
        "completed": "Concluído",
        "draft": "Rascunho",
        "requested": "Solicitado"
      },
      "toasts": {
        "bulk_delete": "Tarefas removidas",
        "bulk_update": "Tarefas atualizadas",
        "completed": "Tarefa concluída",
        "create": "Tarefa criada",
        "delete": "Responsável eliminado",
        "reopened": "Tarefa reaberta",
        "update": "Tarefa atualizada"
      }
    }
  }
}
